

export default {
  queriedTasks: state => state.tasks.filter((task) => {
    let isItemOfCurrentFilter = false
    if ( 
      (state.progressFilter === 'all') 
      || (state.progressFilter === 'belum' && task.belum)
      || (state.progressFilter === 'proses' && task.proses)
      || (state.progressFilter === 'selesai' && task.selesai)
      || (task.tags.includes(state.progressFilter)
    )
    ) { isItemOfCurrentFilter = true }

    return isItemOfCurrentFilter && (task.task_title.toLowerCase().includes(state.progressSearchQuery.toLowerCase()) || task.pekerjaan_sub_nama.toLowerCase().includes(state.progressSearchQuery.toLowerCase()))
  }),
  getTask: state => taskId => state.tasks.find((task) => task.id === taskId),
  getEvent: state => (eventId) => state.events.find((event) => event.id === eventId)
}
